
<script>

  export let label = 'Contagiati';
  export let value = '43';
  export let percentage = '6';
  export let direction = 1; // 1 positivo, 0 pari, -1 negativo
  export let invert = false;

</script>

<div  class="flex flex-col justify-center px-4 py-4 bg-white border border-gray-300 rounded-lg">
    <div>
        <div>
            {#if direction > 0}
                <p class="flex items-center justify-end  text-md" class:text-red-500={!invert} class:text-green-500={invert}>
                    <span class="font-bold">{percentage}%</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-current" viewBox="0 0 24 24"><path class="heroicon-ui" d="M20 15a1 1 0 002 0V7a1 1 0 00-1-1h-8a1 1 0 000 2h5.59L13 13.59l-3.3-3.3a1 1 0 00-1.4 0l-6 6a1 1 0 001.4 1.42L9 12.4l3.3 3.3a1 1 0 001.4 0L20 9.4V15z"/></svg>
                </p>
           {/if}
           {#if direction == 0}
                <p class="flex items-center justify-end text-gray-500 text-md">
                    <span class="font-bold">0%</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-current" viewBox="0 0 24 24"><path class="heroicon-ui" d="M17 11a1 1 0 010 2H7a1 1 0 010-2h10z"/></svg>
                </p>
           {/if}
            {#if direction <  0}
                <p class="flex items-center justify-end  text-md" class:text-green-500={!invert} class:text-red-500={invert}>
                    <span class="font-bold">{percentage}%</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-current" viewBox="0 0 24 24"><path class="heroicon-ui" d="M20 9a1 1 0 012 0v8a1 1 0 01-1 1h-8a1 1 0 010-2h5.59L13 10.41l-3.3 3.3a1 1 0 01-1.4 0l-6-6a1 1 0 011.4-1.42L9 11.6l3.3-3.3a1 1 0 011.4 0l6.3 6.3V9z"/></svg>
                </p>
           {/if}
        </div>
        <p class="text-3xl font-semibold text-center text-gray-800">{value}</p>
        <p class="text-md text-center text-gray-500">{label}</p>
        <p class="text-red-500 text-green-500"></p>
    </div>
</div>
